import { History } from "history";
import { ROUTES } from "../../../../AppRouter";
import * as React from "react";
import { useContext } from "react";
import { AppContext, IAppContext } from "../../../../context/AppContext";
import { fetchSuper, saveSuper } from "../../api/super/SuperApi";
import {
  SuperModel,
  SuperModelErrors
} from "../../../employee/service/super/SuperModel";
import { SuperView } from "./SuperView";
import { fieldValidation } from "../../../../common/Model";
import { required } from "../../../../common/validation/RequiredValidator";
import SuperType from "../../api/SuperType";
import SuperCalculationMethod from "../../api/SuperCalculationMethod";
import StpType from "../../api/StpType";
import { CrudForm } from "../../../../components/widgets/CrudForm";

interface SuperPageProps {
  match: any;
  history: History;
}

const validators = [
  fieldValidation("name", [required]),
  fieldValidation("displayName", [required])
];

const SuperPage: React.FC<SuperPageProps> = ({ history, match }) => {
  const { appState } = useContext<IAppContext>(AppContext);
  const initialModel = {
    name: "",
    displayName: "",
    type: SuperType.GUARANTEE,
    calculationMethod: SuperCalculationMethod.PERCENTAGE_OF_GROSS_WAGES,
    stpType: StpType.GROSS_PAYMENTS,
    amount: 0.0,
    employees: [],
    isValid: false,
    errors: {} as SuperModelErrors
  } as SuperModel;

  return (
    <CrudForm
      id={match.params.id}
      businessId={appState.currentBusinessId}
      validators={validators}
      initialModel={initialModel}
      history={history}
      entityName="super"
      FormViewComponent={SuperView}
      saveModel={saveSuper}
      fetchModel={fetchSuper}
      listRoute={ROUTES.SUPER_LIST}
    />
  );
};

export { SuperPage };
